


























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IntroItem } from '@/common/interface';
import { replaceString } from '@/common/utils/dealWithString';
import getActivityType from '@/common/utils/getActivityType';
import fetch from '@/common/api/fetch';

const loadingImage = require('@/assets/img/loadingImage.gif');

@Component
export default class CourseDetailIntroList extends Vue {
  @Getter('section') section!: any;

  loadingImage: string = loadingImage;
  templateType: string = getActivityType();
  replaceString: Function = replaceString;
  
  get intros(): Array<IntroItem> {
    const tempArray: Array<IntroItem> = [];
    if (this.templateType == 'groupType' || this.templateType == 'solitaireType') {
      // 群接龙、团购
      for (let i: number = 0, length: number = this.section.courseIntros.length; i < length; i++) {
        const item: IntroItem = Object.assign({}, this.section.courseIntros[i]);
        item.value = item.value && replaceString(item.value);

        tempArray.push(item);
      }
    } else if (this.templateType == 'bargainType' || this.templateType == 'tyType') {
      // 砍价、集赞
      for (let i: number = 0, length: number = this.section.prizeIntros.length; i < length; i++) {
        const item: IntroItem = Object.assign({}, this.section.prizeIntros[i]);
        item.value = item.value && replaceString(item.value);
        tempArray.push(item);
      }
    }
    return tempArray;
  }

  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: 'video',
        query: query
      });
    });
  }
}
